<template>
  <div>
    <multiselect
      v-model="model"
      v-if="$root.cache.getOptions[input.id]"
      :options="$root.cache.getOptions[input.id]"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="true"
      placeholder="Seçiniz"
      label="label"
      track-by="label"
      :preselect-first="true"
    ></multiselect>
    <template v-else>Yükleniyor</template>
  </div>
</template>

<script>
import multiselect from "vue-multiselect";
export default {
  name: "multipleSelect",
  components: {
    multiselect,
  },
  data() {
    return {
      model: [],
      options: null,
      // Kayıtta olup seçenek listesinde artık bulunmayan değerler (silinmiş /
      // pasif seçenek). Ekranda gösterilemez ama kayıttan da düşürülmemeli;
      // yoksa lead'i açıp kaydetmek veriyi sessizce siler.
      unknownValues: [],
      valueApplied: false,
    };
  },
  props: ["input", "form", "value", "multiple"],
  created() {
    this.applyValue();
  },
  methods: {
    applyValue() {
      const options = this.$root.cache.getOptions[this.input.id];
      // Seçenekler henüz yüklenmediyse yüklendiğinde tekrar denenir.
      if (this.valueApplied || !this.value || !Array.isArray(options)) return;
      this.valueApplied = true;

      const result = [];
      const unknown = [];
      String(this.value)
        .split(",")
        .filter((item) => item !== "")
        .forEach((item) => {
          const option = options.find((i) => i.value == item);
          if (option) result.push(option);
          else unknown.push(item);
        });
      this.unknownValues = unknown;
      this.model = result;
    },
  },
  mounted() {
    this.options = this.$root.cache.getOptions[this.input.id];
  },
  watch: {
    // Sadece ilk yüklemede seçenekler gelmemişse çalışır; sonraki yeniden
    // yüklemeler kullanıcının seçimini ezmez.
    "$root.cache.getOptions"() {
      this.applyValue();
    },
    form() {
      if (this.form) {
        this.unknownValues = [];
        this.model = null;
      }
    },
    model() {
      // form sıfırlanınca model null olur.
      const selected = (this.model || [])
        .filter((e) => e && e.value != null)
        .map((e) => e.value);
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: selected.concat(this.unknownValues).join(","),
      });
    },
  },
};
</script>

<style></style>
